import { client } from '@atlassian/rovo-content-bridge-api';

export const CONFLUENCE_SPACE_CLIENT_ID = client('confluence-space');
